import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);
};

export default useScrollToTop;